import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminTable from '../AdminTable';
import { MODELS } from '../../../constants/admin/settings';
import {
    fetchEventPartnerDependencies,
    fetchEventPartners,
    createEventPartner,
    sendEmailToEventPartners,
    deleteEventPartners,
    openEventPartner,
    fetchCopyClearanceDependencies,
    copyClearance
} from '../../../actions/admin/models/event.partners';
import AdminModalForm from '../AdminModalForm';
import EventPartnerInputs from '../../../components/admin/lineup/EventPartnerInputs';
import { openModalForm, openModalFormWithData } from '../../../actions/admin/modal.forms';
import { UserContext } from '../../../Application';
import { hasPermissions, PERMISSIONS } from '../../../constants/authentication/permissions';
import { dataSelector, selectedSelector } from '../../../selectors/admin/tables';
import SendEmailInputs from '../../../components/admin/lineup/SendEmailInputs';
import { PER_PAGE_OPTION_2 } from '../../../constants/admin/tables';
import { formDataSelector } from '../../../selectors/admin/forms';
import CopyPartnerClearance from '../../../components/admin/lineup/CopyPartnerClearance';

class EventPartners extends Component {
    state = {
        modalModel: ''
    };
    _deleteEventPartners = () => this.props.deleteEventPartners(this.props.eventId);
    _openMailModal = () => {
        this.setState({ modalModel: MODELS.BULK_PARTNERS_EMAIL });
        this.props.openModalFormWithData(MODELS.BULK_PARTNERS_EMAIL, {
            text: '',
            subject: `[Clear'em] ${this.props.event.name} - Update`
        });
    };
    _openCopyModal = () => {
        this.setState({ modalModel: MODELS.COPY_PARTNER_CLEARANCE });
        this.props.openModalFormWithData(MODELS.COPY_PARTNER_CLEARANCE, {});
    };
    render() {
        const canSendEmail = this.props.selection.length;
        return (
            <UserContext.Consumer>
                {user => (
                    <React.Fragment>
                        <AdminTable
                            openItem={
                                hasPermissions(user, PERMISSIONS.PARTNERS_VIEW) ? this.props.openEventPartner : null
                            }
                            selectionActions={['COPY CLEARANCE FROM', 'SEND EMAIL']}
                            selectionFunctions={[this._openCopyModal, this._openMailModal]}
                            fetchDataFunction={this.props.fetchEventPartners}
                            subContextId={this.props.eventId}
                            model={MODELS.EVENT_PARTNER}
                            buttonAction={this.props.openModalForm}
                            pagination={true}
                            deleteAction={this._deleteEventPartners}
                            forceInitialPages={PER_PAGE_OPTION_2}
                        />
                        {this.state.modalModel === MODELS.COPY_PARTNER_CLEARANCE ? (
                            <AdminModalForm
                                title={`Copy clearance from`}
                                fetchDependencies={this.props.fetchCopyClearanceDependencies}
                                modelId={this.props.eventId}
                                fields={CopyPartnerClearance}
                                staticData={{ eventName: this.props.event.name, for: this.props.selection }}
                                model={MODELS.COPY_PARTNER_CLEARANCE}
                                createAction={this.props.copyClearance}
                                confirmLabel={'Copy'}
                            />
                        ) : null}
                        {this.state.modalModel === MODELS.BULK_PARTNERS_EMAIL ? (
                            <AdminModalForm
                                title={`Send Email to ${canSendEmail} Media Partners`}
                                modelId={this.props.eventId}
                                fields={SendEmailInputs}
                                forceClose={!canSendEmail}
                                model={MODELS.BULK_PARTNERS_EMAIL}
                                createAction={this.props.sendEmailToEventPartners}
                                confirmLabel={'Send'}
                            />
                        ) : null}
                        <AdminModalForm
                            staticData={this.props.eventPartners}
                            title="Add Partners to Event"
                            forceClose={canSendEmail}
                            modelId={this.props.eventId}
                            fields={EventPartnerInputs}
                            model={MODELS.EVENT_PARTNER}
                            fetchDependencies={this.props.fetchEventPartnerDependencies}
                            createAction={this.props.createEventPartner}
                        />
                    </React.Fragment>
                )}
            </UserContext.Consumer>
        );
    }
}

const mapStateToProps = state => ({
    eventPartners: dataSelector(state),
    event: formDataSelector(state, { model: MODELS.EVENT }),
    selection: selectedSelector(state)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchEventPartners,
            openModalForm,
            openModalFormWithData,
            fetchEventPartnerDependencies,
            createEventPartner,
            sendEmailToEventPartners,
            openEventPartner,
            deleteEventPartners,
            fetchCopyClearanceDependencies,
            copyClearance
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(EventPartners);



// WEBPACK FOOTER //
// ./src/containers/admin/events/EventPartners.js